import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', function () {
    const componentCarousels = document.querySelectorAll('.component-carousel');

    if (componentCarousels.length === 0) return;

    // Check if the screen width is less than or equal to 767px (for mobile)
    const isMobile = window.innerWidth <= 767;

    componentCarousels.forEach(componentCarousel => {
        const componentCarouselSwiper = componentCarousel.querySelector('.component-carousel__swiper');

        // Loop through each carousel and remove the unwanted wrapper and class
        const componentCarouselSwiperWrapper = componentCarousel.querySelector('.swiper-wrapper');
        const componentCarouselBlockContainer = componentCarouselSwiperWrapper.querySelector('.acf-innerblocks-container');

        if (componentCarouselBlockContainer) {
            // Move all child elements out of the acf-innerblocks-container
            while (componentCarouselBlockContainer.firstChild) {
                componentCarouselSwiperWrapper.appendChild(componentCarouselBlockContainer.firstChild);
            }
            // Remove the now-empty acf-innerblocks-container which we do not want.
            componentCarouselBlockContainer.remove();
        }

        // Remove the 'swiper-slide' class on larger screens (desktop/tablet)
        if (!isMobile) {
            const slides = componentCarouselSwiperWrapper.querySelectorAll('.swiper-slide');
            slides.forEach(slide => {
                slide.classList.remove('swiper-slide');
            });
        }

        // Initialize Swiper only on mobile
        if (isMobile) {
            new Swiper(componentCarouselSwiper, {
                clickable: true,
                loop: true,
                spaceBetween: 15,
                slidesPerView: 1.5,
                centeredSlides: true,
                navigation: {
                    nextEl: componentCarousel.querySelector('.swiper-button-next'),
                    prevEl: componentCarousel.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: componentCarousel.querySelector('.swiper-pagination'), // Select pagination container within the current carousel
                    clickable: true,
                },
            });
        }
    });
});